<template>
  <div class="fl-sym-mt-10">
    <div class="fl-sym-px-4 fl-sym-mt-1">
      <div
        v-if="success_message != null"
        class="fl-sym-bg-green-400 fl-sym-border fl-sym-border-green-500 fl-sym-px-4 fl-sym-py-3 fl-sym-rounded fl-sym-relative fl-sym-text-white"
        role="alert"
      >
        <span class="fl-sym-block sm:inline">{{ success_message }}</span>
        <span
          class="fl-sym-absolute fl-sym-top-0 fl-sym-bottom-0 fl-sym-right-0 fl-sym-px-4 fl-sym-py-3"
        >
          <svg
            class="fl-sym-fill-current fl-sym-h-6 fl-sym-w-6 fl-sym-text-white"
            role="button"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
          >
            <title>Close</title>
            <path
              d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z"
            />
          </svg>
        </span>
      </div>

      <div class="fl-sym-text-primary fl-sym-text-xxs regular">
        CHANGE PASSWORD
      </div>

      <div
        class="fl-sym-text-black fl-sym-text-5xl fl-sym-leading-tight fl-sym-font-semibold fl-sym-mb-2 heading"
      ></div>
      <div class="fl-sym-text-intermediat fl-sym-text-lg update-text"></div>
      <form class="fl-sym-mt-2 xnpms:fl-sym-mt-16" method="post">
        <input
          placeholder="Old Password"
          v-model="old_password"
          name="old_password"
          type="password"
          class="fl-sym-w-full fl-sym-p-3 fl-sym-text-lg fl-sym-rounded fl-sym-border fl-sym-border-graduate fl-sym-mb-3 focus:fl-sym-outline-none focus:fl-sym-border-secondary fl-sym-placeholder-graduate"
        />
        <span class="error" v-if="errors.old_password">{{
          errors.old_password[0]
        }}</span>
        <input
          placeholder="New Password"
          name="password"
          type="password"
          v-model="password"
          class="fl-sym-w-full fl-sym-p-3 fl-sym-text-lg fl-sym-rounded fl-sym-border fl-sym-border-graduate fl-sym-mb-1 focus:fl-sym-outline-none focus:fl-sym-border-secondary fl-sym-placeholder-graduate"
        />
        <span class="error" v-if="errors.password">{{
          errors.password[0]
        }}</span>

        <input
          placeholder="Confirm Password"
          name="password_confirm"
          type="password"
          v-model="password_confirm"
          class="fl-sym-w-full field__input fl-sym-mt-2 fl-sym-p-3 fl-sym-text-lg fl-sym-rounded fl-sym-border fl-sym-border-graduate fl-sym-mb-1 focus:fl-sym-outline-none focus:fl-sym-border-secondary fl-sym-placeholder-graduate"
        />

        <span class="error" v-if="errors.password_confirm">{{
          errors.password_confirm[0]
        }}</span>

        <div class="loginBtnMargin xs:fl-sym-mt-40 fl-sym-mb-2">
          <button
            type="button"
            @click="submit"
            class="login-btn fl-sym-text-white fl-sym-bg-primary fl-sym-rounded-full fl-sym-text-white fl-sym-p-3 fl-sym-w-full fl-sym-text-sm email-password email-password-text"
          >
            Change Password
          </button>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
// import RestAuthApi from "../../gen/openapi-js/dist/api/RestAuthApi"
export default {
  data() {
    return {
      errors: [],
      old_password: null,
      password: null,
      password_confirm: null,
      success_message: null,
    }
  },

  methods: {
    submit: function() {
      // FIX THIS LATER
      //alert("Inn");
      // var request_body = {
      //   old_password: this.old_password,
      //   password: this.password,
      //   password_confirm: this.password_confirm,
      // };
      // let vm = this;
      // let api = new RestAuthApi();
      // api.restAuthPasswordChangeCreate({
      //   new_password1: this.password,
      //   new_password2: this.new_password2
      // })
    },
  },
}
</script>
<style>
.error {
  top: 460px;
  left: 20px;
  width: 366px;
  height: 16px;
  letter-spacing: var(--unnamed-character-spacing-0);
  text-align: left;
  letter-spacing: 0px;
  opacity: 1;
  font: "SFProDisplay-Regular";
  font-size: 16px;
  color: #ff3a19;
}

.border-red {
  border-color: #ff3a19;
}

.loginBtnMargin {
  margin-top: 20px;
}
.login-btn {
  background: transparent
    linear-gradient(262deg, #19e0ff 0%, var(--progress-bar-filler) 100%) 0% 0%
    no-repeat padding-box;
  background: transparent linear-gradient(262deg, #19e0ff 0%, #00c5e3 100%) 0%
    0% no-repeat padding-box;
  opacity: 1;
}

.email-password {
  background-color: white;
  color: black;
}
.margin-top {
  margin-top: -40px;
}

.back {
  font-family: "SFProDisplay-Semibold";
}

.field {
  position: relative;
  display: inline-block;
}
/* .field__input {
  padding-right: 330px;
} */
.field__helper {
  position: absolute;
  right: 5px;
  top: 20px;
  letter-spacing: var(--unnamed-character-spacing-1-4);
  color: var(--progress-bar-filler);
  text-align: center;
  letter-spacing: 1.4px;
  color: #00c5e3;
  opacity: 1;
  cursor: pointer;
}

.already-account {
  color: var(--unnamed-color-6f7878);
  text-align: center;
  letter-spacing: 0.64px;
  color: #6f7878;
  background-color: #d0dada;
  opacity: 0.6;
}
.email-password-text {
  color: var(--progress-bar-filler);
  text-align: center;
  letter-spacing: 0.64px;
  color: white;
  opacity: 1;
}

.heading {
  font: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-bold)
    var(--unnamed-font-size-28) / var(--unnamed-line-spacing-32)
    var(--unnamed-font-family-sf-pro-display);
  letter-spacing: var(--unnamed-character-spacing--0-16);
  color: var(--unnamed-color-000000);
  text-align: left;
  font: normal normal bold 28px/32px SF Pro Display;
  letter-spacing: -0.16px;
  color: #000000;
  font-weight: bold;
  opacity: 1;
}

.update-text {
  letter-spacing: var(--unnamed-character-spacing-0-56);
  color: var(--unnamed-color-6f7878);
  text-align: left;
  letter-spacing: 0.56px;
  color: #6f7878;
  opacity: 1;
}
</style>
